import { render, staticRenderFns } from "./koneksi.vue?vue&type=template&id=f5b39132&"
import script from "./koneksi.vue?vue&type=script&lang=js&"
export * from "./koneksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports